
export default {
  'filters.title': 'Filters',
  'filters.browse': 'Filters',
  'filters.saved': 'Saved Filters',
  'filters.basic': 'Basic',
  'filters.attributes': 'Attributes',
  'filters.availability': 'Availability',
  'filters.location': 'Location',
  'filters.age_range': 'Age Range',
  'filters.gender': 'Gender',
  'filters.services': 'Services',
  'filters.languages': 'Languages',
  'filters.verification': 'Verification Status',
  'filters.status': 'Status',
  'filters.verified_profiles_only': 'Verified Profiles Only',
  'filters.online_now': 'Online Now',
  'filters.price_range': 'Price Range',
  'filters.all_locations': 'All Locations',
  'filters.search_location': 'Search location...',
  'filters.no_location_found': 'No location found',
  'filters.reset': 'Reset Filters',
  'filters.apply': 'Apply Filters',
  'filters.save': 'Save Filter',
  'filters.filter_name': 'Filter Name',
  'filters.save_current_filter': 'Save current filter',
  'filters.delete': 'Delete',
  'filters.no_saved_filters': 'No saved filters yet',
  'filters.select_filter': 'Select a filter',
  'filters.applied_filters': 'Applied filters:',
  
  // Sort filter options
  'filters.sort_by': 'Sort by',
  'filters.sort_options.newest': 'Newest First',
  'filters.sort_options.popularity': 'Most Popular',
  'filters.sort_options.relevance': 'Most Relevant',
  'filters.show_with_reviews': 'Show profiles with reviews',
  
  // Advanced filters
  'filters.physical_attributes': 'Physical Attributes',
  'filters.height': 'Height',
  'filters.weight': 'Weight',
  'filters.hair_color': 'Hair Color',
  'filters.eye_color': 'Eye Color',
  'filters.body_type': 'Body Type',
  'filters.habits': 'Habits',
  'filters.smoking': 'Smoking',
  'filters.drinking': 'Drinking',
  'filters.available_days': 'Available Days',
  'filters.available_hours': 'Available Hours',
  'filters.from': 'From',
  'filters.to': 'To',
  'filters.select_hour': 'Select hour',
  'filters.select_all': 'Select All',
  'filters.clear': 'Clear',
  
  'filters.options.yes': 'Yes',
  'filters.options.no': 'No',
  'filters.options.occasionally': 'Occasionally',
  
  'filters.hair_colors.blonde': 'Blonde',
  'filters.hair_colors.brown': 'Brown',
  'filters.hair_colors.black': 'Black',
  'filters.hair_colors.red': 'Red',
  'filters.hair_colors.other': 'Other',
  
  'filters.eye_colors.blue': 'Blue',
  'filters.eye_colors.green': 'Green',
  'filters.eye_colors.brown': 'Brown',
  'filters.eye_colors.hazel': 'Hazel',
  'filters.eye_colors.other': 'Other',
  
  'filters.body_types.slim': 'Slim',
  'filters.body_types.athletic': 'Athletic',
  'filters.body_types.average': 'Average',
  'filters.body_types.curvy': 'Curvy',
  'filters.body_types.plus_size': 'Plus Size',
  
  'filters.days.monday': 'Monday',
  'filters.days.tuesday': 'Tuesday',
  'filters.days.wednesday': 'Wednesday',
  'filters.days.thursday': 'Thursday',
  'filters.days.friday': 'Friday',
  'filters.days.saturday': 'Saturday',
  'filters.days.sunday': 'Sunday',
};
